// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'
import { string } from 'yup';

const obj = {
  field: [
    {
      title: "List of keywords",
      attr: "content",
      value: "",
      id: "keywordlist",
      placeholder: "Keyword List",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("List of keywords is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
    {
      title: "Source Language",
      attr: "content",
      value: "",
      id: "sourceLanguage",
      placeholder: "Source Language",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Source Language is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
    {
      title: "Target Language",
      attr: "content",
      value: "",
      id: "targetlanguage",
      placeholder: "Target Language",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Target Language is Required "),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
   
  ],
  example: [
    {
      title: "List of keywords",
      attr: "content",
      value: "Remote Work",
      id: "keywordlist",
      placeholder: "keyword List",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("List of keywords  is Required "),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
    {
      title: "Source Language",
      attr: "content",
      value: "English",
      id: "sourcelanguage",
      placeholder: "Source Language",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Source Language is  Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
    {
      title: "Target Language",
      attr: "content",
      value: "Spanish",
      id: "targetlanguage",
      placeholder: "Target Language",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Target Language is Required  "),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
      let text || "Hello World"; 
      console.log(text);
      }`,
    },
    
  ],

  editor: {
    output: `Deutsch: unbestimmt, nicht definiert, nicht festgelegt, unbekannt.`,
  },
};

export default obj;
